import { render, staticRenderFns } from "./wageComparison.vue?vue&type=template&id=43caea4d&scoped=true&"
import script from "./wageComparison.vue?vue&type=script&lang=js&"
export * from "./wageComparison.vue?vue&type=script&lang=js&"
import style0 from "./wageComparison.vue?vue&type=style&index=0&id=43caea4d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43caea4d",
  null
  
)

export default component.exports